import {
  Box,
  Container,
  Divider,
  Grid,
  Link,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
} from "@material-ui/core";
import { alpha } from "@material-ui/core/styles";
import { toUpper } from "lodash";
import Logo from "./Logo";
import CustomIcon from "../icons/CustomIcon";
import { Link as RouterLink } from 'react-router-dom';

const sections = [
  {
    title: "THÔNG TIN TRƯỜNG",
    links: [
      {
        title: "Browse Components",
        href: "/browse",
      },
      {
        title: "Documentation",
        href: "/docs",
      },
    ],
  },
  {
    title: "Placeholders",
    links: [
      {
        title: "Terms & Conditions",
        href: "#",
      },
      {
        title: "License",
        href: "#",
      },
      {
        title: "Contact",
        href: "#",
      },
    ],
  },
  {
    title: "Social",
    links: [
      {
        title: "Instagram",
        href: "#",
      },
      {
        title: "LinkedIn",
        href: "#",
      },
    ],
  },
];
interface ArrayFooter {
  key: string;
  title: string;
  href: string;
  location: number;
  icon: JSX.Element;
  links: ArrayFooter[];
}
const Footer = (props) => {
  let linkss: ArrayFooter[] = [];
  let linkss2: ArrayFooter[] = [];
  let sectionss: ArrayFooter[] = [];
  let NameSchool = "";
  console.log(props);
  if (props.footerdata.length > 0) {
    props.footerdata.map((el) => {
      if (el.SettingName == "TenTruong") {
        // let Obj:ArrayFooter = {
        //     key:el.SettingName,
        //     title:`${el.SettingStringData}`,
        //     href:null,
        //     location:0,
        //     icon:<CustomIcon  name={"Phone"} fontSize="small" />,
        //     links:null
        //   }
        NameSchool = el.SettingStringData;
      }
      if (el.SettingName == "DiaChiTruong") {
        let Obj: ArrayFooter = {
          key: el.SettingName,
          title: `Địa chỉ: ${el.SettingStringData}`,
          href: null,
          location: 1,
          icon: <CustomIcon name={"Home"} fontSize="small" />,
          links: null,
        };
        linkss.push(Obj);
      }
      if (el.SettingName == "DienThoaiTruong") {
        let Obj: ArrayFooter = {
          key: el.SettingName,
          title: `Điện thoại: ${el.SettingStringData}`,
          href: null,
          location: 2,
          icon: <CustomIcon name={"Phone"} fontSize="small" />,
          links: null,
        };
        linkss2.push(Obj);
      }
      if (el.SettingName == "SoFax") {
        let Obj: ArrayFooter = {
          key: el.SettingName,
          title: `Số Fax: ${el.SettingStringData}`,
          href: null,
          location: 3,
          icon: <CustomIcon name={"FaxIcon"} fontSize="small" />,
          links: null,
        };
        linkss2.push(Obj);
      }
      if (el.SettingName == "EmailTruong") {
        let Obj: ArrayFooter = {
          key: el.SettingName,
          title: `Email: ${el.SettingStringData}`,
          href: null,
          location: 4,
          icon: <CustomIcon name={"Mail"} fontSize="small" />,
          links: null,
        };
        linkss2.push(Obj);
      }
      if (el.SettingName == "Website") {
        let Obj: ArrayFooter = {
          key: el.SettingName,
          title: `Website: ${el.SettingStringData}`,
          href: `https://${el.SettingStringData}`,
          location: 5,
          icon: <CustomIcon name={"Website"} fontSize="small" />,
          links: null,
        };
        linkss2.push(Obj);
      }
    });
    linkss.sort(function (a, b) {
      return a.location - b.location;
    });
    linkss2.sort(function (a, b) {
      return a.location - b.location;
    });
    let Objectnew: ArrayFooter = {
      key: "THONGTINTRUONG",
      title: "THÔNG TIN TRƯỜNG",
      href: null,
      location: 1,
      icon: null,
      links: linkss,
    };
    let Objectnew1: ArrayFooter = {
      key: "THONGTINLIENHE",
      title: "THÔNG TIN LIÊN HỆ",
      href: null,
      location: 2,
      icon: null,
      links: linkss2,
    };
    sectionss.push(Objectnew);
    sectionss.push(Objectnew1);
  }

  return (
    <Box
      sx={{
        backgroundColor: "background.paper",
        pb: 2,
        pt: {
          md: 0,
          xs: 6,
        },
      }}
      {...props}
    >
      <Container maxWidth="lg">
        <Box
          sx={{
            backgroundColor: "background.paper",
            pb: 1,
            pt: {
              md: 1,
              xs: 2,
            },
            pl: {
              // md: 6,
            },
            fontWeight: 600,
          }}
        >
          {toUpper(NameSchool)}
        </Box>
        <Grid container spacing={3}>
          <Grid
            item
            md={2}
            sm={4}
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
              order: {
                md: 1,
                xs: 4,
              },
            }}
            xs={12}
          >
            {/* <Logo /> */}
            <RouterLink to="/">
              <Box
                sx={{
                  // display: "flex",
                  // justifyContent: "center",
                  "& > img": {
                    width: "90%",
                  },
                }}
              >
                <img
                  alt="Auth platform"
                  src="https://daihocchinhquy.neu.edu.vn/Content/logo/neu-logo.png"
                />
              </Box>
            </RouterLink>
            <Typography color="textSecondary" sx={{ mt: 1 }} variant="caption">
              © 2022 PSC.
            </Typography>
          </Grid>
          {sectionss.map((section, index) => (
            <Grid
              item
              key={section.key}
              md={5}
              sm={4}
              sx={{
                order: {
                  md: index + 2,
                  xs: index + 1,
                },
              }}
              xs={12}
            >
              <Typography color="textSecondary" variant="overline">
                {section.title}
              </Typography>
              <List disablePadding>
                {section.links.map((link) => (
                  <ListItem
                    disableGutters
                    key={link.key}
                    sx={{
                      pb: 0,
                      pt: 1,
                    }}
                  >
                    <ListItemAvatar
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        minWidth: 0,
                        mr: 0.5,
                      }}
                    >
                      {link.icon}
                      {/* <MinusIcon color="primary" /> */}
                    </ListItemAvatar>
                    <ListItemText
                      primary={
                        <Link
                          href={link.href}
                          color="textPrimary"
                          variant="subtitle2"
                          target="_blank"
                        >
                          {link.title}
                        </Link>
                      }
                    />
                  </ListItem>
                ))}
              </List>
            </Grid>
          ))}
        </Grid>
        <Divider
          sx={{
            borderColor: (theme) =>
              alpha(theme.palette.primary.contrastText, 0.12),
            mb:1
          }}
        />
        <Typography color="textSecondary" variant="caption">
          All Rights Reserved Developed by{" "}
          <img src="/static/Logo_PSC_white.png" />
        </Typography>
      </Container>
    </Box>
  );
};

export default Footer;
